import { useQuery } from '@tanstack/react-query';
import API from 'PREPAREsrc/service/api';
import { useSelector } from 'react-redux';
import Network from 'PREPAREsrc/service/Network';

export const keys = {
  exerciseWorkspaceTeamStatus: 'exerciseWorkspaceTeamStatus',
};

export const useFetchExerciseWorkspaceTeamStatus = () => {
  const workspaceId = useSelector(
    (state: { prepare: { workspace: { selectedWorkspace: UUID } } }) =>
      state.prepare.workspace.selectedWorkspace
  );
  return useQuery({
    queryKey: [keys.exerciseWorkspaceTeamStatus, workspaceId],
    queryFn: async () => {
      const response = await Network.post(
        API.getExerciseWorkspaceTeamSiteStatus,
        {
          workspaceId,
        }
      );

      return response?.data?.response?.teams_status || response?.data?.info?.creation_status;
    },
  });
};
